/* eslint-disable camelcase */
const candidateOffersTranslations = {
    en: {
        'jobsAvailable_zero': 'No available opportunities',
        'jobsAvailable_one': '{{count}} opportunity',
        'jobsAvailable_other': '{{count}} opportunities',
        'shifts_zero': 'Shifts',
        'shifts_one': '{{count}} shift',
        'shifts_other': '{{count}} shifts',
        'periods_zero': 'Periods',
        'periods_one': '{{count}} period',
        'periods_other': '{{count}} periods',
        viewDetails: 'View details',
        signInToViewDetails: 'Sign in to view details',
        offerStatus: {
            applied: 'Applied',
            declinedByCandidate: 'Declined',
            rejected: 'Rejected',
            confirmed: 'Confirmed'
        },
        mobileTitle: 'Offer details',
        interested: 'Interested',
        rolesSpecialties: 'Roles & specialties',
        decline: 'Decline',
        apply: 'Apply',
        viewAndApply: 'View & Apply',
        declineDialogTitle: 'Decline opportunity',
        declineDialogSubtitle: 'Are you sure you want to decline this opportunity? You could check details later from the "My Jobs" section.',
        confirm: 'Confirm',
        send: 'Send',
        successToastText: 'Sent successfully',
        goBackToOpportunities: 'View opportunities',
        schedule: 'Schedule',
        additionalActions: {
            askForOpportunities: 'Ask for more opportunities',
            askForOpportunitiesDescription: 'Based on your preferences and activity',
            updateAvailability: 'Update availability',
            updateAvailabilityDescription: 'Up-to-date availability helps us to find more suitable assignments for you',
            updatePreferences: 'Update job preferences',
            updatePreferencesDescription: 'Describe your perfect job and we use it as insights to find you the best opportunities'
        },
        dialog: {
            decline: {
                cancel: 'Cancel',
                submit: 'Decline'
            },
            accept: {
                title: 'Apply for opportunity',
                subtitle: 'Please confirm that you apply for <1>{{count}} assignments</1> at {{customer}}',
                subtitle_one: 'Please confirm that you apply for <1>1 assignment</1> at {{customer}}',
                submit: 'Confirm and send'
            }
        },
        replyCommentHeading: 'A note for consultant',
        replyCommentPlaceholder: 'Leave a note for consultant',
        emptyScreenDescription: 'It seems you responded to all sent opportunities or they are not available anymore',
        selectAll: 'Select all',
        shiftsPage: {
            heading: 'Select shifts',
            'selection_zero': 'No shifts selected',
            'selection_one': '{{count}} shift selected',
            'selection_other': '{{count}} shifts selected'
        },
        periodsPage: {
            heading: 'Select periods',
            'selection_zero': 'No periods selected',
            'selection_one': '{{count}} period selected',
            'selection_other': '{{count}} periods selected'
        },
        confirmationPage: {
            heading: 'Confirm submission',
            role: 'Role',
            customer: 'Customer',
            department: 'Department/Project',
            location: 'Location',
            description: 'Description',
            reviewSelection: {
                shifts: 'Review selected shifts',
                weeks: 'Review selected weeks'
            },
            offerNotActualAnymore: {
                title: 'Opportunity not found',
                description: 'This offer is no longer available. Please go back to opportunities list to see the actual offers.'
            }
        },
        errorPage: {
            notFound: {
                title: 'Thank you for interest',
                description: 'Unfortunately, the request is no longer available'
            },
            general: {
                title: 'Something went wrong',
                description: 'Please try again. If the problem persists, contact {{tenantName}} for support.'
            }
        },
        errorActions: {
            openMainPage: 'Open main page',
            refresh: 'Refresh page'
        },
        errors: {
            deprecatedOffer: {
                shifts: 'Number of shifts were updated',
                weeks: 'Number of weeks were updated'
            },
            general: 'Something went wrong. Please check your network connection and try again. If the problem persists,contact {{tenantName}} for support.'
        },
        overview: {
            title: 'Overview',
            openJobs: 'Open jobs',
            newThisWeek: 'New this week',
            notFindingWhatYouAreLookingFor: 'Not finding what you are looking for?',
            askForMoreOpportunities: 'Ask for more opportunities',
            updateJobPreferences: 'Update job preferences',
            refresh: 'Refresh list of jobs',
            openJobsCount: '{{count}} open jobs',
            openJobsCount_one: '{{count}} open job'
        },

        historyPreview: {
            title: 'History',
            subtitle: 'Recent jobs',
            seeAll: 'See all'
        }
    },
    no: {
        'jobsAvailable_zero': 'Ingen oppdrag',
        'jobsAvailable_one': '{{count}} oppdrag',
        'jobsAvailable_other': '{{count}} oppdrag',
        'shifts_zero': 'Vakter',
        'shifts_one': '{{count}} vakt',
        'shifts_other': '{{count}} vakter',
        'periods_zero': 'Perioder',
        'periods_one': '{{count}} perioder',
        'periods_other': '{{count}} perioder',
        periods: 'Perioder',
        viewDetails: 'Se detaljer',
        signInToViewDetails: 'Logg inn for å se detaljer',
        offerStatus: {
            applied: 'Søkt',
            declinedByCandidate: 'Avslått',
            rejected: 'Avvist',
            confirmed: 'Bekreftet'
        },
        interested: 'Interessert',
        rolesSpecialties: 'Roller og spesialiteter',
        decline: 'Avslå',
        apply: 'Søke',
        viewAndApply: 'Les mer og søk',
        declineDialogTitle: 'Avslå oppdrag',
        declineDialogSubtitle: 'Er du sikker på at du vil avslå denne muligheten? Du kan sjekke detaljene senere fra "Mine oppdrag"-seksjonen.',
        schedule: 'Arbeidsplan',
        additionalActions: {
            askForOpportunities: 'Be om flere muligheter',
            askForOpportunities_detailed: 'Be om flere muligheter',
            askForOpportunitiesDescription: 'Basert på dine preferanser og aktivitet',
            updateAvailability: 'Oppdater tilgjengelighet',
            updateAvailabilityDescription: 'Oppdatert tilgjengelighet hjelper oss med å finne mer passende oppdrag for deg',
            updatePreferences: 'Oppdater jobbpreferanser',
            updatePreferencesDescription: 'Beskriv din perfekte jobb, og vi bruker den som innsikt for å finne de beste mulighetene for deg'
        },
        confirm: 'Bekreft',
        send: 'Send',
        successToastText: 'Sendt korrekt',
        goBackToOpportunities: 'Se oppdrag',
        dialog: {
            decline: {
                cancel: 'Avbryt',
                submit: 'Avslå'
            },
            accept: {
                title: 'Søk om mulighet',
                subtitle: 'Bekreft at du søker på {{count}} oppdrag hos {{customer}}',
                subtitle_one: 'Vennligst bekreft at du søker på 1 oppdrag hos {{customer}}',
                submit: 'Bekreft og send'
            }
        },
        replyCommentHeading: 'Beskjed til bemanningsansvarlig',
        replyCommentPlaceholder: 'Legg igjen et notat til konsulent',
        emptyScreenHeading: 'Ingen oppdrag tilgjengelig akkurat nå',
        emptyScreenDescription: 'Det ser ut til at du har svart på alle sendte muligheter, eller de er ikke tilgjengelige lenger. Trykk på “Be om flere muligheter” for å spørre om flere oppdrag.',
        selectAll: 'Velg alle',
        shiftsPage: {
            heading: 'Velg vakter',
            'selection_zero': 'Ingen vakter valgt',
            'selection_one': '{{count}} vakt valgt',
            'selection_other': '{{count}} vakter valgt'
        },
        periodsPage: {
            heading: 'Velg periode',
            'selection_zero': 'Ingen perioder valgt',
            'selection_one': '{{count}} periode valgt',
            'selection_other': '{{count}} perioder valgt'
        },
        confirmationPage: {
            heading: 'Oppdragsoversikt',
            role: 'Rolle',
            customer: 'Kunde',
            department: 'Avdeling/Prosjekt',
            location: 'Lokasjon',
            description: 'Tilleggsinformasjon',
            reviewSelection: {
                shifts: 'Gjennomgå valgte vakter',
                weeks: 'Gjennomgå valgte uker' 
            },
            offerNotActualAnymore: {
                title: 'Dette oppdraget er ikke aktuelt lenger',
                description: 'Vennligst gå tilbake til oppdragslisten for å se de aktuelle oppdragene.'
            }
        },
        errorPage: {
            notFound: {
                title: 'Takk for interessen',
                description: 'Oppdraget er desverre ikke lenger tilgjengelig' 
            },
            general: {
                title: 'Noe gikk galt',
                description: 'Vennligst prøv igjen. Hvis problemet vedvarer,kontakt {{tenantName}} for hjelp.' 
            } 
        },
        errorActions: {
            openMainPage: 'Åpne hovedside',
            refresh: 'Refresh side' 
        },
        errors: {
            deprecatedOffer: {
                shifts: 'Antall vakter ble oppdatert',
                weeks: 'Antall uker ble oppdatert' 
            },
            general: 'Noe gikk galt. Oppdater siden og forsøk igjen. Hvis problemet vedvarer,kontakt {{tenantName}} og vil hjelpe deg.' 
        },

        overview: {
            title: 'Oversikt',
            openJobs: 'Åpne stillinger',
            newThisWeek: 'Nye denne uken',
            notFindingWhatYouAreLookingFor: 'Finner du ikke det du leter etter?',
            askForMoreOpportunities: 'Be om flere muligheter',
            updateJobPreferences: 'Oppdater preferanser',
            refresh: 'Oppdater jobblisten'
        },

        offerPage: {
            heading: 'Oppdrag'
        }
    },
    sv: {
        'jobsAvailable_zero': 'Inget uppdrag',
        'jobsAvailable_one': '{{count}} uppdrag',
        'jobsAvailable_other': '{{count}} uppdrag',
        'shifts_zero': 'Pass',
        'shifts_one': '{{count}} pass',
        'shifts_other': '{{count}} pass',
        'periods_zero': 'Perioder',
        'periods_one': '{{count}} period',
        'periods_other': '{{count}} perioder',
        periods: 'Perioder',
        viewDetails: 'Se detaljer',
        signInToViewDetails: 'Logga in för att se detaljer',
        offerStatus: {
            applied: 'Ansökt',
            declinedByCandidate: 'Avböjt',
            rejected: 'Avvisat',
            confirmed: 'Bekräftat'
        },
        interested: 'Intresserad',
        rolesSpecialties: 'Roller och specialiteter',
        decline: 'Neka',
        apply: 'Ansöka',
        viewAndApply: 'Läs mer och sök',
        declineDialogTitle: 'Neka uppdrag',
        declineDialogSubtitle: 'Är du säker på att du vill neka denna möjlighet? Du kan kontrollera detaljerna senare från avsnittet "Mina jobb".',
        schedule: 'Schema',
        additionalActions: {
            askForOpportunities: 'Be om fler möjligheter',
            askForOpportunities_detailed: 'Be om fler möjligheter',
            askForOpportunitiesDescription: 'Baserat på dina preferenser och aktivitet',
            updateAvailability: 'Uppdatera tillgänglighet',
            updateAvailabilityDescription: 'Uppdaterad tillgänglighet hjälper oss att hitta mer passande uppdrag för dig',
            updatePreferences: 'Uppdatera jobbpreferenser',
            updatePreferencesDescription: 'Beskriv ditt perfekta jobb, och vi använder det som insikter för att hitta de bästa möjligheterna för dig'
        },
        confirm: 'Bekräfta',
        send: 'Skicka',
        successToastText: 'Uppdateringen lyckades',
        dialog: {
            decline: {
                cancel: 'Avbryt',
                submit: 'Neka'
            },
            accept: {
                title: 'Ansök om möjlighet',
                subtitle: 'Bekräfta att du ansöker om {{count}} uppdrag hos {{customer}}',
                subtitle_one: 'Bekräfta att du ansöker om 1 uppdrag hos {{customer}}',
                submit: 'Bekräfta och skicka'
            } 
        },
        goBackToOpportunities: 'Se uppdrag',
        replyCommentHeading: 'Skriv gärna ett meddelande till din konsultchef här',
        replyCommentPlaceholder: 'Lämna ett meddelande till konsulten',
        emptyScreenHeading: 'Inga uppdrag just nu',
        emptyScreenDescription: 'Det verkar som om du svarat på alla skickade möjligheter eller så är de inte tillgängliga längre. Tryck på "Be om fler möjligheter" för att fråga om fler uppdrag.',
        selectAll: 'Välj alla',
        shiftsPage: {
            heading: 'Välj pass',
            'selection_zero': 'Inga pass valda',
            'selection_one': '{{count}} valda pass',
            'selection_other': '{{count}} valda pass'
        },
        periodsPage: {
            heading: 'Välj perioder',
            'selection_zero': 'Inga perioder valda',
            'selection_one': '{{count}} vald period',
            'selection_other': '{{count}} valda perioder'
        },
        confirmationPage: {
            heading: 'Uppdragsöversikt',
            role: 'Roll',
            customer: 'Kund',
            department: 'Avdelning/Prosjekt',
            location: 'Arbetsort',
            description: 'Beskrivning',
            reviewSelection: {
                shifts: 'Se valda pass',
                weeks: 'Se valda veckor' 
            },
            offerNotActualAnymore: {
                title: 'Detta uppdrag är inte aktuellt längre',
                description: 'Vänligen gå tillbaka till uppdragslistan för att se de aktuella uppdragen.'
            }
        },
        errorPage: {
            notFound: {
                title: 'Tack för ditt intresse!',
                description: 'Tyvärr är uppdraget inte tillgängligt längre' 
            },
            general: {
                title: 'Något gick fel',
                description: 'Vänligen forsök igen. Om problemet kvartstår, kontakta {{tenantName}}.' 
            } 
        },
        errorActions: {
            openMainPage: 'Ôppna huvudsidan',
            refresh: 'Uppdadtera sidan' 
        },
        errors: {
            deprecatedOffer: {
                shifts: 'Antal pass är uppdaterade',
                weeks: 'Antal veckor är uppdaterade' 
            },
            general: 'Något gick fel. Kontrollera din Internetn sanslutning och försök igen. Om problemet kvarstår, kontakta {{tenantName}} för support.' 
        },
        overview: {
            title: 'Översikt',
            openJobs: 'Öppna jobb',
            newThisWeek: 'Nya denna vecka',
            notFindingWhatYouAreLookingFor: 'Hittar du inte det du letar efter?',
            askForMoreOpportunities: 'Be om fler möjligheter',
            updateJobPreferences: 'Uppdatera preferenser',
            refresh: 'Uppdatera jobb'
        }
    }
} as const;
export default candidateOffersTranslations;
